//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Screen,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  AllApplicationsApi,
  GetUserDetailsApi,
  registerClientApi,
  setGeneralDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import NotificationIcon from "assets/icons/notification.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
import CreateIcon from "assets/Dashboard/icons/create.svg";
import GetApiIcon from "assets/Dashboard/icons/get-api.svg";
import IntegrateIcon from "assets/Dashboard/icons/integrate.svg";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const Landing = () => {
  //Dispatch
  const dispatch = useDispatch();

  //Slices
  const userDetails = useGetUserDetailsApiDetails();

  useEffect(() => {
    setGeneralDetails({
      activeSideMenuOption: "Getting Started",
    });
    dispatch(GetUserDetailsApi());
  }, []);

  //Render UI
  const TopSection = (
    <DashboardHeader title={`Welcome ${userDetails?.data?.name ?? ""}!`} />
  );

  const BannerSection = (
    <FlexBox
      justifyBetween
      alignEnd
      className="application-banner mr-v-30 br-9 animated fadeInUp delay-01s"
    >
      <FlexBox className="h-100" alignEnd>
        <Image src={ApplicationBannerHand} className="banner-img" />
        <FlexBox flexColumn justifyEvenly className="h-100 mr-l-30">
          <div>
            <p className="font-heavy clr-white fs-16">
              Integrate OTPless into your application
            </p>
            <p className="clr-white fs-14 mr-t-10">
              Follow the integration steps mentioned below
            </p>
          </div>
          <Button
            text={"Get Started"}
            className="w-50"
            onClick={() => {
              setGeneralDetails({
                activeSideMenuOption: "Application",
              });
              ChangeHistory("push", ROUTE_PATH.DASHBOARD.CREATE_APPLICATION);
            }}
          />
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );

  const StepsSection = (
    <div className="steps-section">
      <p className="font-heavy fs-16 mr-b-30 animated fadeInUp delay-02s">
        Steps
      </p>
      <FlexBox justifyBetween className=" animated fadeInUp delay-03s">
        <div className="w-10">
          <Card className="number-card text-center dsp-fl justify-center align-center">
            <Image src={CreateIcon} />
          </Card>
        </div>
        <Card className="w-90">
          <FlexBox justifyBetween alignCenter>
            <div>
              <p className="fs-16 font-medium">Create your Application</p>
              <p className="fs-12 clr-disabled mr-t-5">
                Support all platforms - Android, iOS, Web, Flutter, React
              </p>
            </div>
            <Button
              text={"Start Now"}
              onClick={() => {
                setGeneralDetails({
                  activeSideMenuOption: "Application",
                });
                ChangeHistory("push", ROUTE_PATH.DASHBOARD.CREATE_APPLICATION);
              }}
            />
          </FlexBox>
        </Card>
      </FlexBox>
      <FlexBox justifyBetween className="mr-t-30  animated fadeInUp delay-04s">
        <div className="w-10">
          <Card className="number-card text-center dsp-fl justify-center align-center">
            <Image src={GetApiIcon} />
          </Card>
        </div>
        <Card className="w-90">
          <FlexBox justifyBetween alignCenter>
            <div>
              <p className="fs-16 font-medium">Get API keys</p>
              <p className="fs-12 clr-disabled mr-t-5">
                This is your credential to access SDKs & APIs securely.
              </p>
            </div>
            {/* <Button
              text={"Get Keys"}
              className="underline clr-black no-shadow"
              variant="no-outline"
            /> */}
          </FlexBox>
        </Card>
      </FlexBox>
      <FlexBox justifyBetween className="mr-t-30  animated fadeInUp delay-05s">
        <div className="w-10">
          <Card className="number-card text-center dsp-fl justify-center align-center">
            <Image src={IntegrateIcon} />
          </Card>
        </div>
        <Card className="w-90">
          <FlexBox justifyBetween alignCenter>
            <div>
              <p className="fs-16 font-medium">
                Integrate your SDK into your platform
              </p>
              <p className="fs-12 clr-disabled mr-t-5">
                Get live with “Login with WhatsApp” button within hours.
              </p>
            </div>
            <div className="text-right">
              <a className="fs-12" href={ROUTE_PATH.DOCS.HOME} target={"_self"}>
                Visit Documentation
              </a>
            </div>
            {/* <Button
              text={"View Documents"}
              className="underline clr-black no-shadow"
              variant="no-outline"
            /> */}
          </FlexBox>
        </Card>
      </FlexBox>
    </div>
  );

  //Return UI
  return (
    <DashboardScreen
      className="dashboard-home-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {BannerSection}
      {StepsSection}
    </DashboardScreen>
  );
};

export default Landing;
